/* eslint-disable no-undef */
import React from 'react';
import {createRoot} from 'react-dom/client';
import {Provider} from 'react-redux';
import {BrowserRouter} from 'react-router-dom';
import App from './jsx/App.js';
import store from './redux/redux-store.js';
import reportWebVitals from './reportWebVitals.js';

const root = createRoot(document.querySelector('#root'));

root.render(<BrowserRouter>
	<Provider store={store}>
		<App/>
	</Provider>
</BrowserRouter>);

reportWebVitals();
